export enum MovemmentDateTimeType {
  PREVISION = 'PREVISION',
  DURATION = 'DURATION'
}
